module.exports = __webpack_public_path__ + "static/media/arizona.069fd6e6.svg";